import { render, staticRenderFns } from "./point-order.vue?vue&type=template&id=2a9043a5"
import script from "./point-order.vue?vue&type=script&lang=js"
export * from "./point-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports